export const LOADING_ROUTE_START = 'LOADING/ROUTE_START';
export const LOADING_ROUTE_FINISHED = 'LOADING/ROUTE_FINISHED';
export const LOADING_DATA_START = 'LOADING/DATA_START';
export const LOADING_DATA_FINISHED = 'LOADING/DATA_FINISHED';
export const LOADING_DOWNLOADING_FILE_START = 'LOADING/DATA_START';
export const LOADING_DOWNLOADING_FILE_FINISHED = 'LOADING/DATA_FINISHED';

const initialState = {
  isLoadingRoute: false,
  isLoadingData: false,
  isDownloadingFile: false,
};

export const loadingReducer = (state = initialState, { type }) => {
  switch (type) {
    case LOADING_ROUTE_START: {
      return { ...state, isLoadingRoute: true };
    }
    case LOADING_ROUTE_FINISHED: {
      return { ...state, isLoadingRoute: false };
    }
    case LOADING_DATA_START: {
      return { ...state, isLoadingData: true };
    }
    case LOADING_DATA_FINISHED: {
      return { ...state, isLoadingData: false };
    }
    case LOADING_DOWNLOADING_FILE_START: {
      return { ...state, isDownloadingFile: true };
    }
    case LOADING_DOWNLOADING_FILE_FINISHED: {
      return { ...state, isDownloadingFile: false };
    }
    default:
      return state;
  }
};

export const downloadingFileStart = () => ({
  type: LOADING_DOWNLOADING_FILE_START,
});

export const downloadingFileFinished = () => ({
  type: LOADING_DOWNLOADING_FILE_FINISHED,
});



// WEBPACK FOOTER //
// ./src/reducers/loading.reducer.js